import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Swiper from "swiper/bundle";
import { carouselInfo } from "src/constant/data";
import css from "./HeroSwiper.scss";
import classnames from "classnames/bind";

const cx = classnames.bind(css);
const moduleName = "HeroSwiper";

const HeroSwiper = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const swiper = new Swiper(containerRef.current, {
      loop: true,
      speed: 1200,
      effect: "fade",
      fadeEffect: { crossFade: true },
      autoplay: { delay: 5000, disableOnInteraction: false },
    });
    return () => {
      if (swiper && !swiper.destroyed) swiper.destroy(true, true);
    };
  }, []);

  const captions = [
    { subtitle: "자연 속의 쉼터", title: "자연과 함께하는\n펜션 & 채식농장", cta: "주변전경 보기" },
    { subtitle: "지친 일상을 힐링하세요", title: "마음을 치유하는\n스테이 무릉도원", cta: "객실 소개" },
    { subtitle: "가족, 친구, 연인과 함께", title: "잊지 못할 추억을\n만들어 가세요", cta: "예약 안내" },
  ];
  const links = ["/surrounding", "/room", "/reservation"];

  return (
    <div className={cx(moduleName)}>
      <div className="swiper-container" ref={containerRef}>
        <div className="swiper-wrapper">
          {carouselInfo.map((carousel, i) => (
            <div className="swiper-slide" key={i}>
              <div
                className={cx(`${moduleName}-slide`)}
                style={{ backgroundImage: `url(${require(`../assets/${carousel.img}`)})` }}
              >
                <div className={cx(`${moduleName}-overlay`)} />
                <div className={cx(`${moduleName}-caption`)}>
                  <span className={cx(`${moduleName}-caption-subtitle`)}>
                    {captions[i].subtitle}
                  </span>
                  <h1 className={cx(`${moduleName}-caption-title`)}>
                    {captions[i].title.split("\n").map((line, j) => (
                      <span key={j}>{line}<br /></span>
                    ))}
                  </h1>
                  <Link to={links[i]}>
                    <button className={cx(`${moduleName}-caption-btn`)}>
                      {captions[i].cta}
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={cx(`${moduleName}-scroll`)}>
        <span />
      </div>
    </div>
  );
};

export default HeroSwiper;



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Main/components/HeroSwiper.jsx